import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import { hoverTips } from "utils/mixin";
import Popover from "./popover";
import logger from "utils/logger";

const StyledFilterItems = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 4px;
`;
const StyledFilterItem = styled.div`
  white-space: nowrap;
  cursor: pointer;
  padding: 5px;
  font-size: ${({ theme }) => theme.fontSize.lsmall};
  color: ${({ theme }) => theme.black};
  transition: 0.2s;
  :hover {
    background-color: ${({ theme }) => theme.weakGray};
  }
`;

const FilterItems = ({
  items = [],
  onSelectItem = (item) => logger.log("过滤条件：", item),
}) => {
  return (
    <StyledFilterItems>
      {items.map((item, index) => (
        <StyledFilterItem key={item.value} onClick={() => onSelectItem(item)}>
          {item.desc}
        </StyledFilterItem>
      ))}
    </StyledFilterItems>
  );
};

const StyledFilter = styled.div`
  display: flex;
  column-gap: 5px;
  align-items: baseline;
  padding: ${({ padding }) => padding};
`;

const StyledFilterButton = styled.div`
  display: inline-block;
  padding: 0 5px;
  cursor: pointer;
  color: ${({ theme }) => theme.black};
  opacity: 0.7;
  transition: 0.2s;

  ${({ theme, tips, titlePosition }) =>
    hoverTips(theme, tips, titlePosition.left, titlePosition.top)};

  :hover {
    color: ${({ theme }) => theme.dark};
    opacity: 1;
  }
`;

const StyledInfo = styled.div`
  font-size: ${({ theme }) => theme.fontSize.lsmall};
  color: ${({ theme }) => theme.infoGray};
  user-select: none;
`;

const StyledFilterDesc = styled.div`
  font-size: ${({ theme }) => theme.fontSize.lsmall};
  color: ${({ theme }) => theme.dark};
  font-weight: 600;
`;

const Filter = ({
  items=[],
  onSelectItem,
  itemDesc = "",
  size,
  padding,
  title = "",
  titlePosition = { left: "-100%", top: "-150%" },
  onClick = () => {},
  data,
  children,
  selectName="版本标志",
  ...rest
}) => {
  return (
    <StyledFilter padding={padding}>
      <Popover
        content={
          <FilterItems items={items} onSelectItem={onSelectItem} />
        }
        offset={{ x: "-25%" }}
      >
        <StyledFilterButton
          tips={title ? title : "选择过滤条件"}
          titlePosition={titlePosition}
          onClick={(e) => {
            //阻止事件进一步传播
            // e.stopPropagation();
            onClick(data);
          }}
        >
          <FontAwesomeIcon icon={faFilter} size={size} />
        </StyledFilterButton>
      </Popover>
      <StyledInfo>{selectName}:</StyledInfo>
      <StyledFilterDesc>{itemDesc}</StyledFilterDesc>
    </StyledFilter>
  );
};

export default Filter;
